import { useCallback, useContext, useMemo } from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationContext } from '@msx/platform-services'

export default function useCustomLogService() {

    const { appState } = useContext(ApplicationContext);
    const urlParams = new URLSearchParams(window.location.search);
    const workscopeVersionId = urlParams.get("workscopeVersion") || "";

     const appInsights = useMemo(() => {
        const reactPlugin = new ReactPlugin();
        const ai = new ApplicationInsights({
            config: {
                instrumentationKey: process.env.REACT_APP_INSTRUMENTATION_KEY,
                autoTrackPageVisitTime: true,
                overridePageViewDuration: true,
                extensions: [reactPlugin],
            },
        });
        ai.loadAppInsights();
        return ai.appInsights;
    }, []);

    const trackCustomEvents = useCallback(
        (
            name: string,
            key: string,
            value: string,
            extraProperties: Record<string, any> = {}
        ) => {
            const userName = appState?.user?.email ?? '';
            const eventData = {
                name,
                properties: {
                    ActionKey: key,
                    ActionValue: value,
                    PageName: window?.location?.pathname.split('/')[1],
                    URL: window?.location?.href,
                    UserName: userName,
                    ContextName: 'ECIF Portal',
                    workscopeVersionId: workscopeVersionId,
                    ...extraProperties,
                },
            };
            appInsights.trackEvent(eventData);
        },
        [appState?.user?.email]
    );

    return { trackCustomEvents };
}